import { IEmotionRecordDTO } from "motw_core/DTOs/IEmotionRecordDTO";
import * as React from "react";
import { GetEmotionValuePercentColor } from "../../../KeyValueLogs";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";
import { ShowFirstRecordText } from "./First/ShowFirstRecordText";
import { ShowLastRecordText } from "./Last/ShowLastRecordText";

export function DisplayEmotionRecord({
    isFirstRecord,
    emotionRecord,
    isLastRecord,
}: {
    isFirstRecord: boolean;
    emotionRecord: IEmotionRecordDTO;
    isLastRecord: boolean;
}) {
    return (
        <div
            className={GetValueStyleClass(emotionRecord.percentValue)}
            data-tip={emotionRecord.timePeriodDescription}
        >
            <ShowFirstRecordText
                isFirstRecord={isFirstRecord}
                date={emotionRecord.startDate}
            />
            {emotionRecord.percentValue}
            <ShowLastRecordText
                isLastRecord={isLastRecord}
                date={emotionRecord.endDate}
            />
        </div>
    );
}

function GetValueStyleClass(percentValue: number) {
    const textColor = GetEmotionValuePercentColor(percentValue);

    const valueStyleClass = StyleClass(`emotionRecordValue_${textColor}`, {
        margin: `5px`,
        color: textColor,
        display: `inline-block`,
        fontSize: `24px`,
        position: `relative`,
        ":hover": {
            color: "white",
            textShadow: `0px 0px 10px white`,
        },
    });

    return valueStyleClass;
}
